module.exports = __webpack_public_path__ + "img/shotRoutine1.ac06b1f7.png";